import * as typeformEmbed from '@typeform/embed';
import $ from 'jquery';

export function surveyModalController($modal) {
    const surveyModal = document.querySelector('.survey-modal');

    if (surveyModal) {
        const embedElem = surveyModal.querySelector('.survey-target');
        const surveyElem = surveyModal.querySelector('.survey-url');

        if (embedElem && surveyElem) {
            typeformEmbed.makeWidget(
                embedElem,
                surveyElem.innerText,
                { buttonText: 'Take the survey!' },
            );
        }
    }

    const data = $modal.data();

    $modal.modal({
        show: false,
    });

    // show modal automatically if data-trigger isn't given
    let showModal = true;

    if (data.trigger) {
        $(data.trigger).on('click', (e) => {
            e.preventDefault();
            $modal.modal('show');
        });

        showModal = data.autoshow === true;
    }

    if (showModal) {
        $modal.modal('show');
    }
}
